import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Send from '@icon/Send';
import boxShadowGenerator from '@utils/boxShadowGenerator';

const StyledTextField = styled(TextField)`
  &.MuiFormControl-root {
    .MuiFilledInput-underline:before {
      border-bottom: none;
    }
    .MuiFilledInput-underline:after {
      border-bottom: none;
    }
    .MuiInputBase-root {
      background: var(--color-base-1);
      box-shadow: ${boxShadowGenerator()};
      border-radius: 8px;
      .MuiInputBase-input {
        font-size: 12px;
        color: var(--color-text-secondary);
      }
      .MuiInputBase-input::placeholder {
        font-size: 12px;
        color: var(--color-text-secondary);
      }
      .MuiFilledInput-input {
        padding-top: 12px;
        padding-bottom: 14px;
      }
    }
  }
`;

const StyleSend = styled(Send)`
  cursor: pointer;
`;

const CommentField = (props) => {
  const { onClick, placeholder, ...inputProps } = props;

  return (
    <StyledTextField
      placeholder={placeholder}
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment onClick={onClick} position="end">
            <StyleSend size="24px" color="var(--color-i-green)" />
          </InputAdornment>
        )
      }}
      variant="filled"
      {...inputProps}
    />
  );
};

CommentField.propTypes = {
  onClick: PropTypes.func,
  placeholder: PropTypes.string
};

CommentField.defaultProps = {
  onClick: () => {},
  placeholder: 'Type your comment'
};

export default CommentField;
